import { filter } from 'rxjs/operators';
import { FarmersDetailsService } from './../../../services/farmers-details.service';
import { Component, EventEmitter, OnInit, Output, OnDestroy ,Input} from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject, first } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { JEService } from 'src/app/services/je-services.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JsonPipe } from '@angular/common';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { IpAddressService } from 'src/app/services/ip-address.service';


@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent implements OnInit, OnDestroy {
  @Input() data:any
  uploadOptions: any[];
  selectedCity1: any;
  displayCameraComponent: boolean = false;
  remarks: String;
  items: any[];
  selectedStatus: any;
  isDDAssociate:any;
  // images = [{
  //   source: 'https://via.placeholder.com/301.jpg',
  //   alt: 'Alt1',
  //   title: 'Title1'
  // }, {
  //   source: 'https://via.placeholder.com/302.jpg',
  //   alt: 'Alt2',
  //   title: 'Title2'
  // }, {
  //   source: 'https://via.placeholder.com/303.jpg',
  //   alt: 'Alt3',
  //   title: 'Title3'
  // },
  // {
  //   source: 'https://via.placeholder.com/301.jpg',
  //   alt: 'Alt1',
  //   title: 'Title1'
  // }, {
  //   source: 'https://via.placeholder.com/302.jpg',
  //   alt: 'Alt2',
  //   title: 'Title2'
  // }, {
  //   source: 'https://via.placeholder.com/303.jpg',
  //   alt: 'Alt3',
  //   title: 'Title3'
  // }];
  images = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  // Camera 
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();

  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: this.viewportToPixels('100vw') },
    height: { ideal: 500 },
  };
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  autoId: any;
  miPhysicalAppReqBody: any;
  appId: any;
  editBilledData: boolean = false;

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }


  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  selctedFileType: any;
  applicationNo: any;
  documentList: any = [];
  displayCustom: boolean;
  displayCustomJE: boolean;
  displayCustomSDO: boolean;
  displayCustomXEN: boolean;
  activeIndex: number = 0;
  ParamsAppID: any;
  jeLogin: any;
  jeorxenLogin: any;
  xenLogin: any;
  sdoLogin: any;
  ddmiLogin: any;
  miPhysicalApplicationData: any;
  showListImageJE: boolean = true;
  showListImageSDO: boolean = true;
  showListImageXEN: boolean = true;

  listImagePathJE: any;
  listImagePathSDO: any;
  listImagePathXEN: any;

  userID: any;

  isRPCase: boolean = false;

  userRole: any;
  viewWorkFlowAllStatus: boolean = false;
  ipAddress: any = '000.000.000';

  locationError: string = '';
  capturedLocation: string = '';
  capturedDateTime: string = '';
  deviceName: string = navigator.userAgent;
  isLocationReady: boolean = false;
  locationCoords: { lat: number, lng: number } | null = null;

  // New properties for geofencing
  isInsideFencing: boolean = true;
  fencingError: string = '';

  constructor(
    private _personalDetalSer: FarmersDetailsService, 
    private _fb: FormBuilder, 
    private jeService: JEService, 
    private messageService: MessageService,
    private route: ActivatedRoute, 
    private router: Router, 
    private cryptoJsService: CryptoJsService, 
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService, 
    private activityRecordService: ActivityRecordService,
    private ipService: IpAddressService,
  ) {
    this.uploadOptions = [
      { name: 'Team and Farmer', code: 'team_and_farmer' },
      { name: 'Field Photo', code: 'field_photo' },
      { name: 'Component Photo', code: 'component_photo' },
      { name: 'Farmers Acceptance', code: 'farmers_acceptance' },
      { name: 'Others', code: 'others' }
    ];
    const tokenData = sessionStorage.getItem('token') ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'))) : {}
    if(tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')){ 
      this.jeLogin = true
      this.jeorxenLogin = true
    }
    if(tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')){ 
      this.xenLogin = true
      this.jeorxenLogin = true
    }
    if(tokenData && (tokenData.role == 'SDO')){ 
      this.sdoLogin = true
      // this.jeorxenLogin = true
    }
    if(tokenData && (tokenData.role == 'DDMI')){ 
      this.ddmiLogin = true
      // this.jeorxenLogin = true
    }
    this.route.queryParams
      .subscribe(params => {
        this.ParamsAppID = params.appId
      })

    this.getIP();
  }

  ngOnDestroy(): void {
    this.displayCameraComponent = false;
  }

  ngOnInit(): void {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const editBilledData = loginDetails.get('editBilledData') ? loginDetails.get('editBilledData') : 'No';
    this.userRole = tokenInfo['role'] ? tokenInfo['role'] : null;


    this.editBilledData = editBilledData == 'Yes' ? true : false;


    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.getStatusMaster();

    if (this.jeLogin && sessionStorage.getItem('isRPCase') && sessionStorage.getItem('isRPCase') == 'true') {
      this.isRPCase = true;
      return;
    }

    
    if(this.userRole =='DD Associate'){
      this.isDDAssociate=true
      this.appId=this.data.appId
      this.autoId=this.data.autoId
      if (this.appId) {
        if (JSON.parse(sessionStorage.getItem('documentList'))?.appId == this.appId) {
          this.documentList = JSON.parse(sessionStorage.getItem('documentList'))?.documentList;
        }
        if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))?.length)) {
          if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))[0]?.appID) == this.appId) {
            this.miPhysicalAppReqBody = JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'));
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
            // setTimeout(() => {
            //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
            //   return;
            // }, 1000);
          }

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
          // setTimeout(() => {
          //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
          //   return;
          // }, 1000);
        }

      } else {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
        return;
      }
    }
    else{
      this.isDDAssociate=false
      this.route.queryParams
        .subscribe(params => {
          this.autoId = this.cryptoJsService.DecryptData(params.autoId);
          this.appId = this.cryptoJsService.DecryptData(params.appId);
          if (this.appId) {
            if (JSON.parse(sessionStorage.getItem('documentList'))?.appId == this.appId) {
              this.documentList = JSON.parse(sessionStorage.getItem('documentList'))?.documentList;
            }
            if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))?.length)) {
              if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))[0]?.appID) == this.appId) {
                this.miPhysicalAppReqBody = JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'));
              } else {
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
                // setTimeout(() => {
                //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
                //   return;
                // }, 1000);
              }

            } else {
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
              setTimeout(() => {
                this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
                return;
              }, 1000);
            }

          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
            return;
          }
        }
        );
    }



    this.miPhysicalApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));

      if(this.miPhysicalApplicationData?.listDataForPhysicalVer){ 
      for (let index = 0; index < this.miPhysicalApplicationData?.listDataForPhysicalVer.length; index++) {
          if(this.miPhysicalApplicationData.listDataForPhysicalVer[index].inventory!=null && this.miPhysicalApplicationData.listDataForPhysicalVer[index].inventory.length>0){
          delete this.miPhysicalApplicationData.listDataForPhysicalVer[index].selectedQuantity;
          delete this.miPhysicalApplicationData.listDataForPhysicalVer[index].selectedInventory;
        }
      }
    }

      const isJELogin = loginDetails.get('isJE') ? loginDetails.get('isJE') : null;
      const isSDOLogin = loginDetails.get('isSDO') ? loginDetails.get('isSDO') : null;

      if(isJELogin == '1'){
      this.showListImageJE = false;
      this.showListImageSDO = false;
      this.showListImageXEN = false;
      this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE;
    }
      else if(isSDOLogin == '1'){
      this.showListImageSDO = false;
      this.showListImageXEN = false;
      this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE
      this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathSDO;
    }
      else if(sessionStorage.getItem('isXEN')){
      this.showListImageXEN = false;
      this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE
      this.listImagePathSDO = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathSDO
      this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathXEN;
    }
      else{
      this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE;
      this.listImagePathSDO = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathSDO;
      this.listImagePathXEN = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathXEN;
    }

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
  }

  getStatusMaster() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    let actionId;
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
      actionId = 19; // Do not Change, it is fixed for Farmer Application Verifications
    } else {
      actionId = 18; // Do not Change, it is fixed for Farmer Application Verifications
    }
    this.loader.start();
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.items = data.$values;
          this.selectedStatus = this.items[0];
          this.onSelectStatus();

          if (this.isRPCase) {
            this.items = [this.items[1]];
            this.selectedStatus = this.items;
          }
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }

  goBack() {

  }

  onAttachmentDetailsFormSubmit() {
    if (this.jeLogin && this.isRPCase) {

      let val = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));

      let reqBody =
      {
        "appID": val?.AppID,
        "vendorRegId": val?.VendorCode,
        "progID": val?.ProgId,
        "estimatedAmount": 0,
        "totalBilledAmount": 0,
        "totalCostVerification": 0,
        "billedTransportAmount": 0,
        "maxSubsidyAmount": 0,
        "farmerShareAmount": 0,
        "subsidyToFarmer_Amount": 0,
        "subsidyToVendor_Amount": 0,
        "farmerRefund_Amount": 0,
        "stateShare_Amount": 0,
        "centerShare_Amount": 0,
        "district": val?.District,
        "block": val?.Block,
        "village": val?.Village,
        "miArea": val?.MIArea,
        "plantSpacing": val?.PlantSpacing,
        "rowSpacing": val?.RowSpacing,
        "cropID": val?.CropId,
        "landId": val?.LandIds,
        "userId": this.userID,
        "remarks": this.remarks ? this.remarks : '',
        "network_Id": this.ipAddress,
        "terminal_Id": this.ipAddress,
        "status": this.selectedStatus.flag,
        "proData_MaxSubsidy": 0,
        "surveyType": 0,
        "componentDetail": [],
        "insertServayAttachments": [],
        "insertSurveyGPSCoordiantes": []
      }

      let reqBodyAfterEncypt = {
        "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
      }
      this.loader.start();
      this.jeService.insertPhysicalVerification(reqBodyAfterEncypt).pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody?.appID, new Date(), data, reqBody);
            if (data == 'S:Successfully Submitted') {
              sessionStorage.removeItem('documentList');
              sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
              sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
              sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
              sessionStorage.removeItem('myPhysicalSurveyType')
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
              let val = JSON.parse(window.sessionStorage.getItem('MIPhysicalVerificationPending'));
              val.forEach(val => {
                if (val?.AppID == reqBody?.appID) {
                  val.Status_Ar = 'C';
                  return;
                }
              })
              window.sessionStorage.setItem('MIPhysicalVerificationPending', JSON.stringify(val))
              setTimeout(() => {
                this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
              }, 1200);
            } else if (data == 'S:Successfully Updated') {
              sessionStorage.removeItem('documentList');
              sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
              sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
              sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
              sessionStorage.removeItem('myPhysicalSurveyType')
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Updated' });

              setTimeout(() => {
                this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
              }, 1000);
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.toString() });
            }


          },
          error: (err) => {
            this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody?.appID, new Date(), err, reqBody);
            this.loader.close();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Error! ${err}` });
          }
        });

      return;
    }
    
    // if(this.jeLogin && this.selectedStatus.flag != 'RP'){
    //   let val = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
    //   val?.listDataForPhysicalVer.every(val => val.ActualQuantity == 0)
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error Message',
    //     detail:
    //       "Please Add Component Quantity First",
    //   });
    //   return;
    // }

    this.images = this.documentList;

    let isValid = true;
    // if ((this.images && this.images.length == 0) && this.jeLogin) {
    //   if (this.documentList.length == 0) {
    //     this.messageService.add({ severity: 'error', summary: 'Error Message1', detail: 'Images are Mandatory' });
    //     return;
    //   } else {
    //     this.uploadOptions.forEach(option => {
    //       if (option.code != 'others') {

    //         let filtered = this.documentList.filter(doc => { 
    //           return doc.document_type == option.code 
    //         });
    //         if (filtered?.length == 0) {
    //           this.messageService.add({ severity: 'error', summary: 'Error Message11', detail: 'Atleast one ' + option.name + ' is Needed!' });
    //           isValid = false;
    //           return;
    //         }
    //       }
    //     });
    //   }
    //   if (!isValid) {
    //     return;
    //   }
    // } else {
    //   if (this.images.length == 0) {
    //     this.messageService.add({ severity: 'error', summary: 'Error Message2', detail: 'Images are Mandatory' });
    //     return;
    //   } else {
    //     this.uploadOptions.forEach(option => {
    //       if (option.name != 'Others') {
    //         let filtered = this.images.filter(doc => { 
    //           return doc.DocumentType == option.name 
    //         });
    //         if (filtered?.length == 0) {
    //           this.messageService.add({ severity: 'error', summary: 'Error Message22', detail: 'Atleast one ' + option.name + ' is Needed!' });
    //           isValid = false;
    //           return;
    //         }
    //       }
    //     });
    //   }
    //   if (!isValid) {
    //     return;
    //   }
    // }

    if (this.jeLogin || ((this.xenLogin || this.sdoLogin) && sessionStorage.getItem('myPhysicalSurveyType') == '1')) {
      if (this.documentList.length == 0) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Images are Mandatory' });
        return;
      }
      else {
        this.uploadOptions.forEach(option => {
          if (option.code != 'others') {

            let filtered = this.documentList.filter(doc => {
              return doc.DocumentType == option.code
            });
            if (filtered?.length == 0) {
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Atleast one ' + option.name + ' is Needed!' });
              isValid = false;
              return;
            }
          }
        });
      }
      if (!isValid) {
        return;
      }
    }
    // return;
    if(this.userRole =='DD Associate'){
      if (this.autoId) {

        if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))?.length)) {
          if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))[0]?.appID) == this.appId) {
            this.miPhysicalAppReqBody = JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'));
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
            // setTimeout(() => {
            //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
            //   return;
            // }, 1000);
          }

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
          // setTimeout(() => {
          //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
          //   return;
          // }, 1000);
        }

        let body = [];

        // Note : Only newly captured images has to be sent for the API
        //populating the newly captured images
        this.documentList.forEach(document => {
          body.push({
            "attachmentsDoc": document?.attachment ? document?.attachment : document?.ImagePath,
            "documentType": document?.DocumentType,
          })
        })

        this.miPhysicalAppReqBody[0].insertServayAttachments = body;
        this.miPhysicalAppReqBody[0].remarks = this.remarks ? this.remarks : '';
        this.miPhysicalAppReqBody[0].status = this.selectedStatus.flag;
        let reqBody = this.miPhysicalAppReqBody;

        //Remove 'componentDetail' & 'insertServayAttachments' for department & ADMIN login
        if((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')){
          this.miPhysicalAppReqBody[0].componentDetail = undefined;
          this.miPhysicalAppReqBody[0].insertServayAttachments = undefined;
          reqBody = this.miPhysicalAppReqBody[0];
        }

        let reqBodyAfterEncypt = {
          "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
        }
        this.loader.start();
        this.jeService.insertPhysicalVerification(reqBodyAfterEncypt).pipe(first())
          .subscribe({
            next: (data) => {
              this.loader.close();
              this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody?.appID, new Date(), data, reqBody);

              if (data == 'S:Successfully Submitted') {
                sessionStorage.removeItem('documentList');
                sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
                sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                sessionStorage.removeItem('myPhysicalSurveyType')
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
                let val = JSON.parse(window.sessionStorage.getItem('MIPhysicalVerificationPending'));
                val.forEach(val => {
                  if(val?.AppID == reqBody?.appID){
                    val.Status_Ar = 'C';
                    return;
                  }
                })
                window.sessionStorage.setItem('MIPhysicalVerificationPending', JSON.stringify(val))
                setTimeout(() => {
                  this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                }, 1200);
              } else if (data == 'S:Successfully Updated') {
                sessionStorage.removeItem('documentList');
                sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
                sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                sessionStorage.removeItem('myPhysicalSurveyType')
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Updated' });

                setTimeout(() => {
                  this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                }, 1000);
              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.toString() });
              }


            },
            error: (err) => {
              this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody[0]?.appID, new Date(), err, reqBody[0]);
              this.loader.close();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Error! ${err}` });
            }
          });
      } else {
        this.loader.close();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
      }
    }
    else{
      this.route.queryParams
        .subscribe(params => {
          if (params.autoId) {
            let body = [];

            // Note : Only newly captured images has to be sent for the API
            //populating the newly captured images
            this.documentList.forEach(document => {
              body.push({
                "attachmentsDoc": document?.attachment ? document?.attachment : document?.ImagePath,
                "documentType": document?.DocumentType,
              })
            })

            this.miPhysicalAppReqBody[0].insertServayAttachments = body;
            this.miPhysicalAppReqBody[0].remarks = this.remarks ? this.remarks : '';
            this.miPhysicalAppReqBody[0].status = this.selectedStatus.flag;
            let reqBody = this.miPhysicalAppReqBody;

            //Remove 'componentDetail' & 'insertServayAttachments' for department & ADMIN login
          if((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')){
              this.miPhysicalAppReqBody[0].componentDetail = undefined;
              this.miPhysicalAppReqBody[0].insertServayAttachments = undefined;
              reqBody = this.miPhysicalAppReqBody[0];
            }

            let reqBodyAfterEncypt = {
              "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
            }
            this.loader.start();
            this.jeService.insertPhysicalVerification(reqBodyAfterEncypt).pipe(first())
              .subscribe({
                next: (data) => {
                  this.loader.close();
                  this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody?.appID, new Date(), data, reqBody);
                  if (data == 'S:Successfully Submitted') {
                    sessionStorage.removeItem('documentList');
                    sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                    sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
                    sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                    sessionStorage.removeItem('myPhysicalSurveyType')
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
                    let val = JSON.parse(window.sessionStorage.getItem('MIPhysicalVerificationPending'));
                    val.forEach(val => {
                    if(val?.AppID == reqBody?.appID){
                        val.Status_Ar = 'C';
                        return;
                      }
                    })
                    window.sessionStorage.setItem('MIPhysicalVerificationPending', JSON.stringify(val))
                    setTimeout(() => {
                      this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                    }, 1200);
                  } else if (data == 'S:Successfully Updated') {
                    sessionStorage.removeItem('documentList');
                    sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                    sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
                    sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                    sessionStorage.removeItem('myPhysicalSurveyType')
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Updated' });

                    setTimeout(() => {
                      this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                    }, 1000);
                  }
                  else {
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.toString() });
                  }


                },
                error: (err) => {
                  this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody[0]?.appID, new Date(), err, reqBody[0]);
                  this.loader.close();
                  this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Error ${err}` });
                }
              });
          } else {
            this.loader.close();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
          }
        }
        );
    }

  }

  openCamera() {
    this.displayCameraComponent = true;
    this.locationError = '';
    this.isLocationReady = false;
    this.locationCoords = null;
  }

  onCloseDialog() {
    this.displayCameraComponent = false;
    this.imageCaptured = false;
    this.webcamImage = null;
    this.locationError = '';
    this.isLocationReady = false;
    this.locationCoords = null;
  }

  //Camera
  public async triggerSnapshot(): Promise<void> {
    this.locationError = '';
    this.isLocationReady = false;
    try {
      const loc = await this.getLocation();
      this.locationCoords = loc;
      this.capturedLocation = `Lat: ${loc.lat.toFixed(6)}, Lng: ${loc.lng.toFixed(6)}`;
      const now = new Date();
      this.capturedDateTime = now.toLocaleString();
      this.isLocationReady = true;
      this.trigger.next();
    } catch (err) {
      this.locationError = typeof err === 'string' ? err : 'Unable to fetch GPS location. Please enable location services.';
      this.isLocationReady = false;
      this.messageService.add({ severity: 'error', summary: 'Location Error', detail: this.locationError });
    }
  }

  // Add watermark to image after capture
  public handleImage(webcamImage: WebcamImage): void {
    if (!this.isLocationReady || !this.locationCoords) {
      this.messageService.add({ severity: 'error', summary: 'Location Error', detail: 'Unable to fetch GPS location. Please enable location services.' });
      return;
    }

    if(this.jeLogin || ((this.xenLogin || this.sdoLogin) && JSON.parse(sessionStorage.getItem('myPhysicalSurveyType')) == 1)){
      // Geofencing check
      this.isInsideFencing = false;
      this.fencingError = '';
      let polygonCoords = [];
      let geoFencingCoords = [];

      if(this.jeLogin){
        geoFencingCoords = JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'));
      }else if(this.sdoLogin){
        geoFencingCoords = JSON.parse(sessionStorage.getItem('miPhysicalAppSDOGPSCoordinates'));
      }else if(this.xenLogin){
        geoFencingCoords = JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates'));
      }

      try {
        const gpsCoordinate = geoFencingCoords;
        const polygonRaw = gpsCoordinate?.[0];
        if (polygonRaw) {
          polygonCoords = polygonRaw;
          // Expecting array of {lat, lng}
          if (Array.isArray(polygonCoords) && polygonCoords.length > 2) {
            this.isInsideFencing = this.isPointInPolygon(this.locationCoords, polygonCoords);
            if (!this.isInsideFencing) {
              this.fencingError = 'Captured Image/Photo seems outside from correct location on concerned farmer field. Kindly re-capture from right location.';
            }
          } else {
            this.fencingError = 'Geo-fencing polygon data is invalid.';
          }
        } else {
          this.fencingError = 'Geo-fencing polygon data not found.';
        }
      } catch (e) {
        this.fencingError = 'Error reading geo-fencing data.';
      }
    }
    

    const img = new Image();
    img.src = webcamImage.imageAsDataUrl;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      const match = this.deviceName.match(/\(([^)]+)\)/);
      const result = match ? match[1] : null;

      // Watermark text
      const watermarkText1 = `Device Info: ${result ? result : this.deviceName}`;
      const watermarkText2 = `Location: ${this.capturedLocation}`;
      const watermarkText3 = `Date & Time: ${this.capturedDateTime}`;

      ctx.font = 'bold 15px Arial';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';

      // Word wrap utility
      function wrapText(context, text, x, y, maxWidth, lineHeight) {
        const words = text.split(' ');
        let line = '';
        let lines = [];
        for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + ' ';
          const metrics = context.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
            lines.push(line.trim());
            line = words[n] + ' ';
          } else {
            line = testLine;
          }
        }
        lines.push(line.trim());
        for (let i = 0; i < lines.length; i++) {
          context.fillText(lines[i], x, y + i * lineHeight);
        }
        return lines.length;
      }

      // Watermark area config
      const margin = 5;
      const topPadding = 5;
      const betweenPadding = 3;
      const lineHeight = 15;
      const maxTextWidth = Math.min(canvas.width - margin * 2, 320); // max 320px or canvas width

      // Calculate wrapped lines for each watermark text
      let linesArr = [];
      linesArr.push(watermarkText1);
      linesArr.push(watermarkText2);
      linesArr.push(watermarkText3);

      // Calculate total lines for box height
      let totalLines = 0;
      let lineCounts = [];
      for (let i = 0; i < linesArr.length; i++) {
        const words = linesArr[i].split(' ');
        let line = '';
        let count = 0;
        for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + ' ';
          const metrics = ctx.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxTextWidth && n > 0) {
            count++;
            line = words[n] + ' ';
          } else {
            line = testLine;
          }
        }
        count++;
        lineCounts.push(count);
        totalLines += count;
      }

      const boxWidth = maxTextWidth + margin * 2;
      const boxHeight = topPadding + (lineHeight + betweenPadding) * totalLines + margin;
      const boxX = margin;
      const boxY = canvas.height - boxHeight - margin;

      // Draw black rectangle for watermark background
      ctx.save();
      ctx.globalAlpha = 0.1;
      ctx.fillStyle = '#fcfbfbff';
      // ctx.fillStyle = 'black';
      ctx.fillRect(boxX, boxY, boxWidth, boxHeight);
      ctx.restore();

      // Draw white text with wrapping
      ctx.fillStyle = '#fdfd05ff';
      // ctx.fillStyle = 'white';
      let y = boxY + topPadding;
      let lineIdx = 0;
      for (let i = 0; i < linesArr.length; i++) {
        const linesUsed = wrapText(ctx, linesArr[i], boxX + margin, y, maxTextWidth, lineHeight);
        y += linesUsed * lineHeight + betweenPadding;
        lineIdx += linesUsed;
      }

      const watermarkedDataUrl = canvas.toDataURL('image/jpeg');
      this.webcamImage = Object.assign({}, webcamImage, { imageAsDataUrl: watermarkedDataUrl });
      this.imageCaptured = true;
      this.pictureTaken.emit(this.webcamImage);
    };
  }

  // Utility: Point-in-polygon check (Ray-casting algorithm)
  private isPointInPolygon(point: {lat: number, lng: number}, polygon: Array<{lat: number, lng: number}>): boolean {
    let x = point.lng, y = point.lat;
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      let xi = polygon[i].lng, yi = polygon[i].lat;
      let xj = polygon[j].lng, yj = polygon[j].lat;
      let intersect = ((yi > y) !== (yj > y)) &&
        (x < (xj - xi) * (y - yi) / (yj - yi + 0.0000001) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  // Get GPS location before allowing capture
  async getLocation(): Promise<{lat: number, lng: number}> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation not supported');
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          },
          (error) => {
            reject('Unable to fetch GPS location. Please enable location services.');
          }
        );
      }
    });
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    const arr = this.webcamImage.imageAsDataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.selctedFileType + '.jpeg', { type: mime })
    let data = new FormData();
    data.append('file', file);
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = (JSON.parse(payload)?.sub).trim();
    if(this.userRole =='DD Associate'){
      if (this.autoId) {
        this._personalDetalSer
          .uploadFile(data, phNo, this.selctedFileType.code)
          .subscribe((resp: any) => {
            if (resp.statusCode == 200) {
              this.documentList.push({
                attachment: resp.data,
                attachmentRawUrl: this.webcamImage.imageAsDataUrl,
                DocumentType: this.selctedFileType.code,
                displayName: this.cryptoJsService.DecryptData(this.appId) + '_',
                name:
                  this.selctedFileType.code === 'team_and_farmer'
                    ? 'team_and_farmer'
                    : this.selctedFileType.code === 'field_photo'
                      ? 'field_photo'
                      : this.selctedFileType.code === 'farmers_acceptance'
                        ? 'farmers_acceptance'
                        : this.selctedFileType.code === 'others'
                          ? 'others'
                          : 'Component Photo',
                isUploaded: false,
              });

              let documentListObject = {
                'appId': this.cryptoJsService.DecryptData(this.appId),
                'documentList': this.documentList
              }
              sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
              this.selctedFileType = '';
              this.retake();
              this.displayCameraComponent = false;
            } else {
            }
            this.selctedFileType = '';
          });

      } else {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
      }
    }
    else{
      this.route.queryParams
        .subscribe(params => {
          if (params.autoId) {
            this._personalDetalSer
              .uploadFile(data, phNo, this.selctedFileType.code)
              .subscribe((resp: any) => {
                if (resp.statusCode == 200) {
                  this.documentList.push({
                    attachment: resp.data,
                    attachmentRawUrl: this.webcamImage.imageAsDataUrl,
                    DocumentType: this.selctedFileType.code,
                    displayName: this.cryptoJsService.DecryptData(params.appId) + '_',
                    name:
                      this.selctedFileType.code === 'team_and_farmer'
                        ? 'team_and_farmer'
                        : this.selctedFileType.code === 'field_photo'
                          ? 'field_photo'
                          : this.selctedFileType.code === 'farmers_acceptance'
                            ? 'farmers_acceptance'
                            : this.selctedFileType.code === 'others'
                              ? 'others'
                              : 'Component Photo',
                    isUploaded: false,
                  });

                  let documentListObject = {
                    'appId': this.cryptoJsService.DecryptData(params.appId),
                    'documentList': this.documentList
                  }
                  sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
                  this.selctedFileType = '';
                  this.retake();
                  this.displayCameraComponent = false;
                } else {
                }
                this.selctedFileType = '';
              });

          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
          }
        }
        );
    }

  }

  retake() {
    this.imageCaptured = false;
  }

  onAttachmentsFormGoBack() {
    this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
  }

  // imageClick(index: number) {
  //   this.activeIndex = index;
  //   this.displayCustom = true;
  // }

  imageClick(index: number, type) {
    this.activeIndex = index;
    if(type == "JE"){
      this.displayCustomJE = true;
    }
    else if(type == "XEN"){
      this.displayCustomXEN = true;
    }
    else if(type == "SDO"){
      this.displayCustomSDO = true;
    }
    else if(type == "PA"){
      this.displayCustom = true;
    }
  }

  removeCaptureImg(i){
    this.documentList.splice(i, 1)
    let documentListObject = {
      'appId': this.cryptoJsService.DecryptData(this.ParamsAppID),
      'documentList': this.documentList
    }
    sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
  }

  workFlowAllStatus(){
    this.viewWorkFlowAllStatus = true;
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  onSelectStatus() {
    if (this.selectedStatus.flag == 'A') {
      if (this.userID.startsWith('D.A')) {
        this.remarks = 'Checked and Verified';
      } else if (this.userID.startsWith('DDMI')) {
        this.remarks = 'Recommended';
      } else if (this.userID.startsWith('DMICADA')) {
        this.remarks = 'Approved';
      }
    } else {
      this.remarks = null;
    }
  }

}
